/** 课程中心 - 资源管理 **/

import http from '../http'

// 课程提供方
const getCourseProviderList = (params) =>
  http
    .get(`/theUserIdentity/courseDefine/getCourseProviderList`, { params })
    .then((res) => res.data)

// 新建课程
const addCourse = (params) =>
  http
    .post(`/theUserIdentity/courseDefine/addCourse`, params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)

// 编辑课程
const updateCourse = (params) =>
  http
    .post(`/theUserIdentity/courseDefine/updateCourse`, params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data)

// 平台资源管理-详情查询
const getCourseDetail = (params) =>
  http
    .get(`/theUserIdentity/courseDefine/getCourseDetail`, { params })
    .then((res) => res.data)

// 课程资源-获取课程类型列表
const getCourseTypeTapList = (params) =>
  http
    .get('/theUserIdentity/courseTypeDefine/getCourseTypeTapList', { params })
    .then((res) => res.data)

// 查询教育局学年学期
const getYearTerm = (params) =>
  http
    .get('/theUserIdentity/courseDefine/getYearTerm', { params })
    .then((res) => res.data)

// 获取学校关联教育局列表-运营端
const getRelEdu = (params) =>
  http
    .get('/theUserIdentity/courseDefine/getRelEdu', { params })
    .then((res) => res.data)

// 查看文件详情
const getFileInfo = (params) =>
  http.get('/getFileInfo', { params }).then((res) => res.data)
// 获取学校关联教育局列表-学校端
const getRelEduBySchool = (params) =>
  http.get('/school/courseDefine/getRelEdu', { params }).then((res) => res.data)

export default {
  getCourseProviderList,
  addCourse,
  updateCourse,
  getCourseDetail,
  getCourseTypeTapList,
  getYearTerm,
  getRelEdu,
  getFileInfo,
  getRelEduBySchool
}
